// profit-preview.api.ts
import axios from "axios";
import Config from "../../config";
import RefreshTokenHandler from "./refresh-token";

const API_BASE_URL = Config.baseUrl || "http://localhost:3000";

const generatePreview = async (data: {
  company_code: string;
  fund_code: string;
  profit_month: string;
  profit_inputs: any;
}) => {
  const url = `${API_BASE_URL}/profit-preview/generate`;

  try {
    const result: any = await axios.post(url, data, {
      headers: {
        Authorization: sessionStorage.getItem("token") || "",
      },
    });
    return result;
  } catch (err: any) {
    if (err?.response?.data?.status === 401) {
      const responseToHandle = err.response.data;
      const refreshResult = await RefreshTokenHandler.handleIt(
        responseToHandle
      );

      if (refreshResult.status) {
        return await generatePreview(data);
      } else {
        throw err;
      }
    } else {
      throw err;
    }
  }
};

const getPreview = async (
  preview_session_id: string,
  params?: {
    page_number?: number;
    page_size?: number;
    sortBy?: string;
    order?: string;
    search?: string;
    status?: string;
  }
) => {
  const url = `${API_BASE_URL}/profit-preview/${preview_session_id}`;

  try {
    const result: any = await axios.get(url, {
      params,
      headers: {
        Authorization: sessionStorage.getItem("token") || "",
      },
    });
    return result;
  } catch (err: any) {
    if (err?.response?.data?.status === 401) {
      const responseToHandle = err.response.data;
      const refreshResult = await RefreshTokenHandler.handleIt(
        responseToHandle
      );

      if (refreshResult.status) {
        return await getPreview(preview_session_id, params);
      } else {
        throw err;
      }
    } else {
      throw err;
    }
  }
};

const getPreviewSummary = async (preview_session_id: string) => {
  const url = `${API_BASE_URL}/profit-preview/${preview_session_id}/summary`;

  try {
    const result: any = await axios.get(url, {
      headers: {
        Authorization: sessionStorage.getItem("token") || "",
      },
    });
    return result;
  } catch (err: any) {
    if (err?.response?.data?.status === 401) {
      const responseToHandle = err.response.data;
      const refreshResult = await RefreshTokenHandler.handleIt(
        responseToHandle
      );

      if (refreshResult.status) {
        return await getPreviewSummary(preview_session_id);
      } else {
        throw err;
      }
    } else {
      throw err;
    }
  }
};

const deletePreview = async (preview_session_id: string) => {
  const url = `${API_BASE_URL}/profit-preview/${preview_session_id}`;

  try {
    const result: any = await axios.delete(url, {
      headers: {
        Authorization: sessionStorage.getItem("token") || "",
      },
    });
    return result;
  } catch (err: any) {
    if (err?.response?.data?.status === 401) {
      const responseToHandle = err.response.data;
      const refreshResult = await RefreshTokenHandler.handleIt(
        responseToHandle
      );

      if (refreshResult.status) {
        return await deletePreview(preview_session_id);
      } else {
        throw err;
      }
    } else {
      throw err;
    }
  }
};

export const profitPreviewAPI = {
  generatePreview,
  getPreview,
  getPreviewSummary,
  deletePreview,
};
